import React from "react";
import IconButton from "../IconButton";

export type PillPurpose =
	| "primary"
	| "secondary"
	| "success"
	| "danger"
	| "warning"
	| "info"
	| "light"
	| "dark"
	| "link"
	| "plain";

export interface PillProps {
	active?: boolean;
	purpose: PillPurpose;
	className?: string;
	text: string;
	busy?: boolean;
	onClick?: (event: React.MouseEvent) => void;
	onRemoveClick?: (event: React.MouseEvent) => void;
}

const Pill: React.FC<PillProps> = ({ className, purpose, busy, text, onClick, onRemoveClick }) => {
	return (
		<div className={`pill ${purpose} ${className}`} onClick={busy ? () => {} : onClick}>
			<span>{text}</span>
			{onRemoveClick && (
				<IconButton
					icon={busy ? "spinner-third" : "trash-alt"}
					classes={`${busy ? "box-shadow-focus-none" : ""} flat pill-btn`}
					busy={busy}
					type="solid"
					onClick={busy ? () => {} : onRemoveClick}
					ariaLabel={"Remove"}
				/>
			)}
		</div>
	);
};

export default Pill;
